export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 25, 50, 100, 150, 200, 250];
